import { Either } from 'src/utils/either';
import { endpoints } from 'src/utils/axios';

import { httpResponseHandler } from 'src/http/http-response-handler';

import { eventTypeItem } from 'src/types/analytics/analytics';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';

export class AnalyticsRepository {
  constructor(private api: HttpTypes.HttpClient) { }

  async sendLogs(
    params: { logs: eventTypeItem[]; }
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.analytics.eventsMany,
      body: params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async sendAuthErrorLog(
    log: eventTypeItem
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.analytics.eventsMany,
      body: { logs: [log] },
      headers: {
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3ZTI5NWE2MTk2YjQ0NDQ4ZDM5N2Y0YyIsImRhdGEiOnsiX2lkIjoiNjdlMjk1YTYxOTZiNDQ0NDhkMzk3ZjRjIiwibmFtZSI6IkxvZyBFcnJvciIsImVtYWlsIjoibG9nQGVycm9yLmlvIiwiY3BmIjoiOTk5MTExOTk5MTEiLCJ3YWxsZXQiOiJpR2g3QWVKWmN2WFo4VGtpIiwidXNlclNlc3Npb24iOiI2N2UyOTc3ZmIxYjgwNzg4YTU4MjE2YzMiLCJpbnZvaWNlTG9jYXRpb25zIjpbXSwidGllciI6InNpbHZlciJ9LCJhY2Nlc3MiOlsidXNlciIsInJveGNvZGUiXSwiaWF0IjoxNzQyOTAzMTY3LCJleHAiOjQ4OTg2NjMxNjd9.nrVXkXMeU8Ze874yubzs4HWpNYn3fODAP34vesFfGrE'
      }
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
